import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const saveAssetsDone = (_, { payload }) => {
  return [
    ...payload
  ]
}

const addAssetDone = (assets, {payload}) =>{
  let rooms = assets;
  for(var i=0;i<rooms.length;i++){
    if(rooms[i].id === payload[0].id){
      rooms[i] = payload[0];
    }
  }
  return rooms;
}

const updateAssetDone = (assets, {payload}) => {
  let rooms = assets;
  for(var i=0;i<rooms.length;i++){
    if(rooms[i].id === payload[0].id){
      rooms[i] = payload[0];
    }
  }
  return rooms;
}

const deleteAssetDone = (a, { payload })=>{
  let area = a.filter( a => a.areaId === payload.areaId)[0];
  let assets = area.assets.filter( a => a.id !== payload.assetId);
  area = { ...area,assets};
  let rooms = [];
  for(var i=0;i<a.length;i++){
    if(a[i].areaId === payload.areaId){
      rooms.push(area)
    }else{
      rooms.push(a[i])
    }
  }
  return rooms;
}

const fetchAssetByIdDone = (assets, { payload }) => {
  return [
    ...assets,
    payload,
  ];
};

const fetchAssetNotesDone = (assets, { payload }) => {
  return assets.map(p => {
    if (p.id === payload.id) {
      return {
        ...p,
        notes: payload.notes,
      };
    }
    return p;
  });
};

const fetchAssetDocumentsDone = (assets, { payload }) => {
  return assets.map(p => {
    if (p.id === payload.id) {
      return {
        ...p,
        documents: payload.documents,
      };
    }
    return p;
  });
};

const fetchSuiteAssetsDone = (assets, { payload }) => {
  return [
    ...payload
  ];
};

const clearAssetsDone = () => {
  return []
}

const initialState = [];

export default createReducer(initialState, {
  [TYPES.SAVE_ASSETS_DONE] : saveAssetsDone,
  [TYPES.ADD_ASSET_DONE]: addAssetDone,
  [TYPES.UPDATE_ASSET_DONE]:updateAssetDone,
  [TYPES.DELETE_ASSET_DONE]:deleteAssetDone,
  [TYPES.FETCH_ASSET_BY_ID_DONE]: fetchAssetByIdDone,
  [TYPES.FETCH_ASSET_NOTES_DONE]: fetchAssetNotesDone,
  [TYPES.FETCH_ASSET_DOCUMENTS_DONE]: fetchAssetDocumentsDone,
  [TYPES.FETCH_SUITE_ASSETS_DONE]: fetchSuiteAssetsDone,
  [TYPES.CLEAR_ASSETS]:clearAssetsDone
});
